import { koneOnlineHttp } from '@/utils/axios/index'
import type { Response } from '#/axios'
import { OnlinePermissionResponse } from '../types/userMgr'

enum Api {
  token = '/v2/api/auth/token',
  permission = '/v2/api/auth/user/permission',
  logout = '/v2/api/auth/logout'
}

export const tokenApi = (data: any) =>
  koneOnlineHttp.get<Response<any>>({
    url: Api.token,
    data,
    withCredentials: true,
    headers: { 'Content-Type': '', Accept: 'text/html' }
  })

export const permissionApi = (data: any) =>
  koneOnlineHttp.get<OnlinePermissionResponse>({
    url: `${Api.permission}?from=pc`,
    data
  })

export const logoutRemoteApi = (data: any) =>
  koneOnlineHttp.get<Response<OnlinePermissionResponse>>({
    url: Api.logout,
    data
  })
